import CreditScore from '../cards/credit-score';
import { PrimaryBorrowerEmail } from '../cards/email';
import { LastExperience } from '../cards/last-experience';
import LoanType from '../cards/loan-type';
import WelcomeCard from '../cards/welcome/full';
import { Card, End } from '../components/deck';
import Coborrower from './branches/coborrower';
import { creditAuthorizationBranch } from './branches/credit-authorization';
import Disqualifying from './branches/disqualifying';
import Employment from './branches/employment';
import { RefiLiensBranch } from './branches/refi-liens';
import Refinance from './branches/refinance';
import { VeteranStatusCompleted } from './branches/veteran-status-completed';

export default Card(
  WelcomeCard,
  Refinance(
    VeteranStatusCompleted(
      Card(
        LoanType,
        RefiLiensBranch(
          Employment(
            'borrower',
            Card(
              CreditScore,
              Coborrower(
                Disqualifying(
                  creditAuthorizationBranch(
                    Card(PrimaryBorrowerEmail(false), Card(LastExperience, End()))
                  )
                )
              )
            )
          )
        )
      )
    )
  )
);



// WEBPACK FOOTER //
// ./src/decks/refi-full.js